import React from "react";
import { MapPin, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ROLES = [
  { title: "Independent Sales Broker", location: "Vancouver, BC", type: "1099 / Commission" },
  { title: "Independent Sales Broker", location: "Toronto, ON", type: "1099 / Commission" },
  { title: "Independent Sales Broker", location: "Calgary, AB", type: "1099 / Commission" },
  { title: "Independent Sales Broker", location: "New York, NY", type: "1099 / Commission" },
  { title: "Independent Sales Broker", location: "Seattle, WA", type: "1099 / Commission" },
];

export default function Careers() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Careers</div>
          <h1 className="mt-3 font-display font-black text-4xl md:text-6xl max-w-3xl">Move freight. Build a career.</h1>
          <p className="mt-5 text-slate-300 max-w-2xl">We're building our Independent Sales Broker network across North America. If you know freight, own your book, and want a partner with real capacity and 310,000 sq ft of Canadian warehousing behind you — let's talk.</p>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Open roles</div>
          <h2 className="mt-2 font-display font-black text-3xl md:text-4xl text-[#0B3D6E]">Join the team</h2>
          <div className="mt-10 divide-y divide-gray-200 border-t border-b border-gray-200">
            {ROLES.map((r, i) => (
              <div key={`${r.title}-${r.location}`} className="py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-testid={`career-role-${i}`}>
                <div>
                  <div className="font-display font-bold text-lg text-[#0B3D6E]">{r.title}</div>
                  <div className="mt-1 text-sm text-slate-600 flex flex-wrap items-center gap-4">
                    <span className="inline-flex items-center gap-1"><MapPin className="h-4 w-4" />{r.location}</span>
                    <span className="inline-flex items-center gap-1"><Briefcase className="h-4 w-4" />{r.type}</span>
                  </div>
                </div>
                <Link to="/contact" className="inline-flex items-center gap-2 text-[#2E7BC7] font-semibold text-sm hover:gap-3 transition-all">
                  Apply <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
